import React, { useState } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location =
          parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = ""

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <>
      <Form onSubmit={(event) => onSubmit(event)} className="vivabo-login">
        <div className="vivabo-wrapper">
          <div className="vivabo-form-group">
            <div className="vivabo-form-content">
              <div>
                <p className="title-vivabo">{translate("Title")}</p>
              </div>
              <div className="vivabo-form-container vivabo-form-container-login">
                <input
                  disabled={onLogin}
                  placeholder={translate("PlaceholderUserName")}
                  onChange={e => setUsername(e.target.value)}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="login"
                  id="login"
                  className="user-input-vivabo"
                />
              </div>
              <div className="vivabo-form-container">
                <input
                  required={true}
                  disabled={onLogin}
                  placeholder={translate("PlaceholderPassword")}
                  onChange={e => setPassword(e.target.value)}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  name="login"
                  className="user-input-vivabo"
                >
                </input>
              </div>
              <div className="vivabo-button">
                {!onLogin ? (
                  <button type="submit" disabled={!props.turnstileSuccess}>
                    <span className="vivabo-enter-text">
                      {translate("ButtonEnter")}
                    </span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>
              <div className="vivabo-turnstile-wrap">
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              </div>
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
